import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { OutsideProcessContractsSentButNotReceivedReportDto } from "@interfaces/dto/reports/OutsideProcessContractsSentButNotReceivedReportDto.interface";
import { ReportService } from "@services/report.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "outsideProcessContractsSentButNotReceived",
	styleUrls: ["outsideProcessContractsSentButNotReceived.css"],
	templateUrl: "outsideProcessContractsSentButNotReceived.html"
})
export class OutsideProcessContractsSentButNotReceivedReportAdminComponent {
	headerPrimaryButtons: AdminHeaderButton[] = [{ icon: "fal fa-chart-line", method: "close", text: "Reports" }];
	headerSecondaryButtons: AdminHeaderButton[] = [{ icon: "fal fa-envelope-open-text", method: "generateReport", text: "Generate & Email Report" }];
	parameters: OutsideProcessContractsSentButNotReceivedReportDto = new OutsideProcessContractsSentButNotReceivedReportDto();
	title = "Outside Process Contracts sent but not received";

	constructor(private reportService: ReportService, private router: Router, private toastService: ToastService) {
	}

	close() {
		this.router.navigate(["admin/menu/reports/"]);
	}

	generateReport() {
		this.reportService.outsideProcessContractsSentButNotReceived(this.parameters)
			.subscribe(
				() => this.toastService.success("Report Queued - Please await results by email."),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}
}
